import React, { useEffect, useState } from 'react';

import axios from 'axios';

import { useFormikContext } from 'formik';
import routes from 'app/routes';

import { Form as BootstrapForm } from 'react-bootstrap5';

function FormInfo() {
  const [memberInfo, setMemberInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const {
    values: {
      member,
    },
    touched,
  } = useFormikContext();

  useEffect(() => {
    if (member == null) {
      setMemberInfo(null);
    } else {
      setLoading(true);
      axios
        .get(routes.api.students.show(member), {
          params: {
            last_completed_program: true,
          },
        })
        .then((resp) => {
          setLoading(false);
          setMemberInfo(resp.data.data);
        });
    }
  }, [
    member,
    touched.member,
  ]);

  if (loading) {
    return <div>Please, wait...</div>;
  }

  if (memberInfo === null) {
    return '';
  }

  return (
    <>
      <BootstrapForm.Group>
        <BootstrapForm.Label required>
          Program
          <abbr className="ms-1" title="required">*</abbr>
        </BootstrapForm.Label>

        <BootstrapForm.Control
          type="text"
          disabled
          required
          value={memberInfo.attributes.last_program.title}
        />
      </BootstrapForm.Group>

      <BootstrapForm.Group>
        <BootstrapForm.Label required>
          Completed
          <abbr className="ms-1" title="required">*</abbr>
        </BootstrapForm.Label>

        <BootstrapForm.Control
          type="text"
          disabled
          required
          value={
          memberInfo.attributes.last_program.last_session_completed_date
        }
        />
      </BootstrapForm.Group>
    </>
  );
}

export default FormInfo;
